<template>
  <div class="form-section mb-0">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>Dirección domiciliaria</label>
          <input
            type="text"
            v-model="form.address"
            autocomplete="off"
            placeholder="Ingresar dirección domiciliaria"
            class="custom-form-control"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Ubigeo domicilio</label>
          <SearchableDropdown
            placeholder="Elegir ubigeo"
            :options="districts"
            :oldValue="form.ubigeo"
            @selected="form.ubigeo = $event"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Ubigeo nacimiento</label>
          <SearchableDropdown
            placeholder="Elegir ubigeo nacimiento"
            :options="districts"
            :oldValue="form.birthUbigeo"
            @selected="form.birthUbigeo = $event"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Teléfono personal</label>
          <input
            type="text"
            v-model.trim="form.personalPhone"
            autocomplete="off"
            placeholder="Ingresar teléfono"
            maxlength="9"
            class="custom-form-control"
            :class="{ 'custom-form-control-error': v.personalPhone && v.personalPhone.$error }"
          />
          <FormError
            v-if="v.personalPhone && v.personalPhone.$error && !v.personalPhone.numeric"
            message="Teléfono debe ser numérico"
          />
          <FormError
            v-if="v.personalPhone && v.personalPhone.$error && !v.personalPhone.mobile"
            message="Ingresa un teléfono válido de 9 dígitos"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Correo personal</label>
          <input
            type="email"
            v-model.trim="form.personalEmail"
            autocomplete="off"
            placeholder="Ingresar correo personal"
            class="custom-form-control"
            :class="{ 'custom-form-control-error': v.personalEmail && v.personalEmail.$error }"
          />
          <FormError
            v-if="v.personalEmail && v.personalEmail.$error && !v.personalEmail.email"
            message="Ingresa un correo electrónico válido"
          />
        </div>
      </div>

    </div>

    <!-- Contacto de emergencia -->
    <div class="row mt-2">
      <div class="col-md-12">
        <h2 class="form-subtitle">Contacto de emergencia</h2>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Nombre del contacto</label>
          <input
            type="text"
            v-model="form.emergencyContact"
            autocomplete="off"
            placeholder="Ingresar nombre del contacto"
            class="custom-form-control"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Parentesco</label>
          <FormSelect
            id="emergencyContactRelationship"
            v-model="form.emergencyContactRelationship"
            :items="relationshipList"
            defaultOption="Elegir parentesco"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group mb-0">
          <label>Teléfono de emergencia</label>
          <input
            type="text"
            v-model.trim="form.emergencyPhoneNumber"
            autocomplete="off"
            placeholder="Ingresar teléfono de emergencia"
            maxlength="9"
            class="custom-form-control"
            :class="{ 'custom-form-control-error': v.emergencyPhoneNumber && v.emergencyPhoneNumber.$error }"
          />
          <FormError
            v-if="v.emergencyPhoneNumber && v.emergencyPhoneNumber.$error && !v.emergencyPhoneNumber.numeric"
            message="Teléfono debe ser numérico"
          />
          <FormError
            v-if="v.emergencyPhoneNumber && v.emergencyPhoneNumber.$error && !v.emergencyPhoneNumber.mobile"
            message="Ingresa un teléfono válido de 9 dígitos"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FormError, FormSelect, SearchableDropdown } from 'wize-admin'
import { Constants } from '@/core/utils'

export default {
  components: { FormError, FormSelect, SearchableDropdown },
  props: {
    form:      { type: Object, required: true },
    v:         { type: Object, required: true },
    districts: { type: Array,  default: () => [] },
  },
  data() {
    return {
      relationshipList: Object.values(Constants.EmergencyRelationship),
    }
  },
}
</script>

<style lang="stylus" scoped></style>
